import BridgeV2 from "@akulaku/web-bridge";
import { pick } from "lodash";

type PlatformType = "android" | "ios" | "browser";

export default function getPlatform(): Promise<{ deviceType: PlatformType; appVersion?: number }> {
  return new Promise((resolve) => {
    if (BridgeV2 && BridgeV2.isAkulaku()) {
      BridgeV2.getEnvInfoSilent("", (res: any): void => {
        const { deviceType, appVersionCode } = pick(res.data, ["deviceType", "appVersionCode"]);
        // device-type 这里取的是文本.
        resolve({ deviceType, appVersion: appVersionCode });
      });
    } else {
      resolve({ deviceType: "browser" });
    }
  });
}
